import { ActivatedRoute, Router } from "@angular/router";
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { listLanguages, Languages } from "src/models/language.model";
import { Subscription } from "rxjs";
import { UtilService } from "src/app/services/util.service";
import { CrudService } from "src/app/services/crud.service";
import { RestaurantService } from "src/app/services/restaurant.service";

//import * as moment from "moment";
import moment from "moment-timezone";
import { ThemePalette } from "@angular/material/core";
import { DatePipe } from "@angular/common";
import { IonModal, Platform } from "@ionic/angular";
import { Capacitor } from "@capacitor/core";
import { CalendarService } from "src/app/services/calendar.service";
import { AuthService } from "src/app/services/auth.service";
import { UserType } from "src/models/user.model";
import { KitchenTypesComponents } from "src/app/components/kitchen-types/kitchen-types.component";
import { listServices } from "src/models/services.model";
import { NgxCaptureService } from "ngx-capture";
import { tap } from "rxjs/operators";
import { register } from "swiper/element/bundle";
import {
  Estabelecimento,
  EstabelecimentoResponse,
} from "src/models/estabelecimento.model";

register();

@Component({
    selector: "app-reservation-form",
    templateUrl: "./reservation-form.component.html",
    styleUrls: ["./reservation-form.component.scss"],
    providers: [DatePipe],
    standalone: false
})
export class ReservationFormComponent implements OnInit {
  @Input() showHeader = false;
  @Input() contentDisplayType = "flex";
  @Input() public selectedRestaurantDashboard = null;
  @Input() public calendarWidth = "100vw";
  @ViewChild(IonModal) modal: IonModal;
  @ViewChildren("row") row: QueryList<HTMLElement>;
  sub: Subscription;
  languages: { value: number; label: string }[] = listLanguages;
  services: { value: number; label: string }[] = listServices;
  formReserv: UntypedFormGroup;
  gambys = true;
  restaurants = [];
  claim: UserType;
  userType = UserType;
  dateNow = new Date();
  isOpenDetailBooking = false;
  hoursAvaiable: any;
  dataBooking: any;
  textDesconto: string;
  walkIn = false;
  commentsEnable: boolean;
  disableBook = true;
  public dateControl = new UntypedFormControl(new Date());
  public date: moment.Moment;
  public disabled = false;
  public showSpinners = true;
  public showSeconds = false;
  public touchUi = false;
  public enableMeridian = true;
  public minDate = new Date();
  public stepHour = 1;
  public stepMinute = 1;
  public stepSecond = 1;
  public color: ThemePalette = "primary";
  dataClient = {} as any;
  slideOpts = {
    initialSlide: 0,
    slidesPerView: 2,
    scrollbar: true,
    pager: true,
    speed: 400,
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: true,
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      dynamicBullets: true,
    },
    onInit: (slides: any) => {
      this.swiper = slides;
    },
  };
  nome: any;
  celular: any;
  // idiomas: any;
  sameRestaurant: any;
  vendedor: any;
  isPwa: boolean;
  isQrCode = false;
  daysweek = [];
  hoursoperation = [];
  selectedweek: any;
  selectedhour;
  openedCalendar = false;
  @ViewChild("kitchen") kitchen: KitchenTypesComponents;
  @ViewChild("restaurantSlides") restaurantSlides: any;
  @ViewChild("reservationInfo") screen: any;
  chosenRestaurant: any;
  qrCodeUrl = "";
  isBrochure: boolean;
  restaurantMap: any;
  swiper: any;
  selectedKitchen: any;
  selectedDate: boolean;
  isSharing: boolean;
  allRestaurants: Estabelecimento[];
  Languages = Languages;
  constructor(
    public fb: UntypedFormBuilder,
    public util: UtilService,
    public router: Router,
    public route: ActivatedRoute,
    private crud: CrudService,
    private restaurantService: RestaurantService,
    private datepipe: DatePipe,
    private platform: Platform,
    private calendarService: CalendarService,
    private auth: AuthService,
    private captureService: NgxCaptureService,
    private changeDetector: ChangeDetectorRef,
  ) {}

  async ngOnInit() {
    this.crud.getData(`restaurante`).subscribe(
      async (response: EstabelecimentoResponse) => {
        console.log(response);
        this.allRestaurants = response.data;
      },
      (error) => {},
    );

    this.formReserv = this.fb.group({
      nome: ["", Validators.required],
      celular: ["", Validators.required],
      restaurante: ["", Validators.required],
      idiomas: [[Languages.English], Validators.required],
      servicos: [[]],
      "quantidade-pessoas": [1],
      "data-escolhida": [
        this.datepipe.transform(this.dateControl.value, "yyyy/MM/dd hh:mm a"),
      ],
      valor: [0, Validators.required],
      observation: [""],
      walkIn: [false],
    });

    this.claim = await this.auth.getClaim();
    this.daysweek = this.calendarService.createDaysWeek();
    this.selectedweek = this.daysweek[0];

    this.route.params.subscribe((data) => {
      if (data) {
        this.disableBook = true;

        this.vendedor = { id: data.vendedorId };
        this.isQrCode = data.isQrCode;
        this.dataClient = JSON.parse(sessionStorage.getItem("dataClient"));
        const { nomeCliente, celular } =
          this.dataClient != null
            ? this.dataClient
            : { nomeCliente: "", celular: "" };
        this.formReserv.get("nome").setValue(nomeCliente);
        this.formReserv.get("celular").setValue(celular);
      }
      if (sessionStorage.getItem("oldReservation")) {
        const oldReservation = JSON.parse(
          sessionStorage.getItem("oldReservation"),
        );
        this.sameRestaurant = oldReservation.restaurante;
        this.nome = oldReservation.nomeCliente;
        this.celular = oldReservation.celular;
        this.vendedor = oldReservation.vendedor;
        this.formReserv.get("restaurante").setValue(this.sameRestaurant.id);
        this.formReserv.get("idiomas").setValue(oldReservation.idiomas);
        this.formReserv.get("servicos").setValue(oldReservation.servicos);
        this.formReserv.get("nome").setValue(this.nome);
        this.formReserv.get("celular").setValue(this.celular);

        this.getListRestaurantsByKitchen(this.sameRestaurant.tipoCozinha);
        this.selectedRestaurant(this.sameRestaurant);
      }

      if (sessionStorage.getItem("restaurantMap")) {
        const restaurantMap = JSON.parse(
          sessionStorage.getItem("restaurantMap"),
        );
        this.restaurantMap = restaurantMap;
        this.getListRestaurantsByKitchen(this.restaurantMap.tipoCozinha);
        this.selectedRestaurant(this.restaurantMap);
      }

      this.isPwa = !Capacitor.isNativePlatform();
    });

    console.log(
      "selectedRestaurantDashboard",
      this.selectedRestaurantDashboard,
    );

    if (this.selectedRestaurantDashboard) {
      this.getListRestaurantsByKitchen(
        this.selectedRestaurantDashboard.tipoCozinha,
      );
      this.selectedRestaurant(this.selectedRestaurantDashboard);
    }
  }

  checkValue(language): boolean {
    return language.value === Languages.English;
  }

  openComment(): void {
    this.commentsEnable = true;
  }
  async initSwiper(gfdgf) {
    this.swiper = await this.restaurantSlides.getSwiper();
    if (this.restaurantMap) {
      this.swiper.slideTo(
        this.restaurants.findIndex((res) => res.id === this.restaurantMap.id),
        500,
      );
    }
  }

  async ionViewDidEnter() {
    if (this.restaurantSlides) {
      this.swiper = await this.restaurantSlides.getSwiper();
      if (this.restaurantMap) {
        this.swiper.slideTo(
          this.restaurants.findIndex((res) => res.id === this.restaurantMap.id),
          500,
        );
      }
    }
  }

  getListRestaurantsByKitchen(kitchen) {
    this.crud.getData(`restaurante?tipoCozinhaId=${kitchen.id}`).subscribe(
      (response: any) => {
        this.restaurants = response.data.sort((a, b) =>
          a["tipoEstabelecimento"] > b["tipoEstabelecimento"]
            ? -1
            : a["tipoEstabelecimento"] === b["tipoEstabelecimento"]
              ? 1
              : 0,
        );
      },
      (error) => {},
    );
  }

  filterRestaurantById(restaurant) {
    return this.restaurants.find((res) => res.id === restaurant);
  }

  eventKitchenSelected(kitchen) {
    this.restaurants = [];
    this.selectedKitchen = kitchen;
    this.chosenRestaurant = null;
    this.formReserv.get("restaurante").setValue("");
    this.formReserv.get("valor").setValue(0);
    this.getListRestaurantsByKitchen(this.selectedKitchen);
    this.modal.present();
  }

  selectedRestaurant(restaurant, shouldScroll = false) {
    console.log(restaurant);
    this.chosenRestaurant = restaurant;
    this.formReserv.get("restaurante").setValue(restaurant.id);
    this.setHourAvaible(restaurant.horariosFuncionamento[0]);
    this.openedCalendar = false;

    if (restaurant.tipoEstabelecimento === "BROCHURE") {
      this.disableBook = false;
    }
    if (restaurant.tipoEstabelecimento !== "BROCHURE") {
      this.calculateValue();
    }

    if (shouldScroll) {
      this.row.changes.subscribe((comps: QueryList<ElementRef>) => {
        if (comps.first.nativeElement)
          this.scrollSelect(comps.first.nativeElement);
      });
    }
  }

  languagesAvailable() {
    if (this.chosenRestaurant !== null && this.chosenRestaurant !== undefined) {
      return this.languages.filter((item) =>
        this.chosenRestaurant.idiomas.includes(item.value),
      );
    }
    return this.languages;
  }

  servicesAvailable() {
    if (this.chosenRestaurant !== null && this.chosenRestaurant !== undefined) {
      return this.services.filter((item) =>
        this.chosenRestaurant.servicos.includes(item.value),
      );
      // return (this.services = this.services.filter((item) =>
      //   this.chosenRestaurant.servicos.includes(item.value)
      // ));
    }
    return this.services;
  }

  calculateValue() {
    const restaurante = this.formReserv.get("restaurante").value;
    const pessoas = this.formReserv.get("quantidade-pessoas").value;

    this.crud
      .getData(
        `restaurante/reserva/valor-restaurante/${restaurante}/${pessoas}`,
      )
      .subscribe((response: { data: number }) => {
        this.formReserv.get("valor").setValue(response.data);
      });
  }

  setHourAvaible({
    horarioConvertidoAbertura,
    horarioConvertidoFechamento,
  }: {
    horarioConvertidoAbertura: number;
    horarioConvertidoFechamento: number;
  }) {
    if (horarioConvertidoAbertura && horarioConvertidoFechamento) {
      const listHours = [];

      for (
        let hour = horarioConvertidoAbertura;
        hour <= horarioConvertidoFechamento;
        hour++
      ) {
        listHours.push(hour.toString());
      }

      this.hoursAvaiable = listHours;
    }
  }

  ionViewWillLeave() {
    sessionStorage.removeItem("oldReservation");
    sessionStorage.removeItem("restaurantMap");
  }

  sendRequestSame() {
    sessionStorage.removeItem("oldReservation");

    this.util.showLoading();
    if (this.formReserv.invalid) {
      return false;
    }

    const data = this.formReserv.value;

    data.idVendedor = this.vendedor.id;

    data.vendedor = this.vendedor;

    const restaurant = this.sameRestaurant;

    this.dataBooking = {
      ...data,
      restaurant,
    };

    this.restaurantService.requestReservSame(data).subscribe(
      async (response: any) => {
        await this.util.showToast("Your reservation was sent successfully");
        this.isBrochure = restaurant.tipoEstabelecimento == "BROCHURE";
        if (restaurant.tipoEstabelecimento === "BROCHURE") {
          this.qrCodeUrl = response.data.walkin
            ? `https://www.gospread.online/#/call/reservations-requests/${response.data.id}`
            : `https://www.gospread.online/#/call/history-restaurants/${response.data.id}`;
          // this.textDesconto = response.data.restaurante.textoDesconto;
        } else {
          this.qrCodeUrl = "https://www.gospread.site/partner/become-a-partner";
        }

        this.isOpenDetailBooking = true;

        this.formReserv.reset();
        this.formReserv.get("idiomas").setValue([Languages.English]);
        this.formReserv.get("quantidade-pessoas").setValue(1);
        this.ngOnInit();
        this.disableBook = true;
        await this.util.hideLoading();
      },
      async (error) => {
        await this.util.showToast(
          "An error occurred while trying to book your reservation",
        );
        await this.util.hideLoading();
      },
    );
  }

  async closeModal() {
    await this.modal.dismiss();
  }

  async scroll(el: HTMLElement) {
    await this.closeModal();
    el.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start",
    });
  }

  async scrollSelect(el: HTMLElement) {
    // el
    // setTimeout(() => {
    //   el.scrollTo({
    //     behavior: "smooth",
    //     // block: "nearest",
    //     // inline: "start",
    //   });
    // }, 5000);

    setTimeout(() => {
      el.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "start",
      });
    }, 1000);

    // setTimeout(() => {
    // el.scrollBy({
    //   behavior: "smooth",
    //   // block: "nearest",
    //   // inline: "start",
    // });
    // }, 5000);
  }

  setWalkIn() {
    if (!this.walkIn) {
      this.walkIn = true;
      this.formReserv.get("data-escolhida").setValue("");
      this.disableBook = false;
    } else {
      this.walkIn = false;
      this.disableBook = true;
      this.formReserv
        .get("data-escolhida")
        .setValue(
          this.datepipe.transform(this.dateControl.value, "yyyy/MM/dd hh:mm a"),
        );
    }
  }
  public getServiceDescription(service: number) {
    return this.services.filter((s) => s.value === service)[0].label;
  }
  async sendRequest(closeModal = false) {
    if (this.formReserv.invalid) {
      await this.util.hideLoading();
      return false;
    }

    await this.util.showLoading();

    const data = this.formReserv.value;
    console.log(data);
    console.log(this.restaurants);
    const restaurant = this.allRestaurants.find(
      (r) => data.restaurante === r.id,
    );

    this.dataBooking = {
      ...data,
      restaurant,
    };

    const reservation =
      restaurant.tipoEstabelecimento != "BROCHURE"
        ? this.restaurantService.requestReserv(data)
        : this.restaurantService.requestReservBrochure(data);

    reservation.subscribe(
      async (response: any) => {
        if (closeModal) {
          await this.modal.dismiss();
        }

        await this.util.showToast(
          "Your reservation request was sent successfully",
        );

        this.isBrochure = restaurant.tipoEstabelecimento == "BROCHURE";

        if (restaurant.tipoEstabelecimento != "BROCHURE") {
          this.qrCodeUrl = response.data.walkin
            ? `https://www.gospread.online/#/call/reservations-requests/${response.data.id}`
            : `https://www.gospread.online/#/call/history-restaurants/${response.data.id}`;
          this.textDesconto = response.data.restaurante.textoDesconto;
        } else {
          this.qrCodeUrl = "https://www.gospread.site/partner/become-a-partner"; //TODO: add brochure url
        }

        console.log(this.qrCodeUrl);

        this.isOpenDetailBooking = true;
        this.formReserv.reset();
        this.formReserv.get("idiomas").setValue([Languages.English]);
        this.formReserv.get("quantidade-pessoas").setValue(1);
        if (this.kitchen) this.kitchen.selectedItem = -1;
        this.disableBook = true;
        this.restaurants = [];
        await this.util.hideLoading();
        this.ngOnInit();
      },
      (error) => {
        this.util.showToast(
          "An error occurred while trying to book your reservation",
        );
        this.util.hideLoading();
      },
    );
  }
  getConfirmationText() {
    return this.claim === this.userType.Passenger
      ? "Please take a screenshot and present this page at establishment's check-in"
      : "Present this QR Code at establishment's check-in";
  }

  getTitle() {
    return this.isBrochure
      ? "Digital Brochure"
      : "Your reservation has been successfully requested!";
  }

  getNote() {
    return this.isBrochure
      ? "This is a referral of our digital Brochure. It is not valid as a reservation neither as a discount coupon in establishments that are not GoSpread Partners."
      : "Note: in case of late arrival, your reservation may be subject to the establishment availability.";
  }

  async sendRequestClient() {
    if (this.formReserv.invalid) {
      await this.util.hideLoading();
      return false;
    }

    await this.util.showLoading();

    const data = this.formReserv.value;

    data.idVendedor = this.vendedor.id;

    data.vendedor = this.vendedor;

    const restaurant = this.restaurants.find((r) => data.restaurante);

    this.dataBooking = {
      ...data,
      restaurant,
    };

    this.restaurantService.requestReservClient(data).subscribe(
      async (response: any) => {
        await this.util.showToast(
          "Your reservation request was sent successfully",
        );
        this.isBrochure = restaurant.tipoEstabelecimento == "BROCHURE";
        if (restaurant.tipoEstabelecimento != "BROCHURE") {
          this.qrCodeUrl = response.data.walkin
            ? `https://www.gospread.online/#/call/reservations-requests/${response.data.id}`
            : `https://www.gospread.online/#/call/history-restaurants/${response.data.id}`;
          this.textDesconto = response.data.restaurante.textoDesconto;
        } else {
          this.qrCodeUrl = "https://www.gospread.site/partner/become-a-partner"; //TODO: add brochure url
        }

        this.isOpenDetailBooking = true;
        this.formReserv.reset();
        this.formReserv.get("idiomas").setValue([Languages.English]);
        this.formReserv.get("quantidade-pessoas").setValue(1);
        this.ngOnInit();
        this.kitchen.selectedItem = -1;
        this.restaurants = [];
        this.disableBook = true;
        await this.util.hideLoading();
        this.selectedDate = false;
      },
      (error) => {
        this.util.showToast(
          "An error occurred while trying to book your reservation",
        );
        this.util.hideLoading();
      },
    );
  }

  async gotoHome() {
    if (this.claim === this.userType.Restaurant) {
      await this.router.navigateByUrl("call/reservations-requests");
    } else if (this.claim === this.userType.Caller) {
      await this.router.navigateByUrl("call/dashboard");
    } else {
      this.kitchen.selectedItem = -1;
      this.restaurants = [];
      this.formReserv.reset();
      const { nomeCliente, celular } =
        this.dataClient != null
          ? this.dataClient
          : { nomeCliente: "", celular: "" };
      this.formReserv.get("nome").setValue(nomeCliente);
      this.formReserv.get("celular").setValue(celular);
      this.formReserv.get("idiomas").setValue([Languages.English]);
      this.formReserv.get("quantidade-pessoas").setValue(1);
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      await this.router.navigate([this.route.url]);
    }
    this.isOpenDetailBooking = false;
  }

  async shareReserv() {
    // console.log("shareReserv");
    // await this.util.showLoading();
    // await this.util.hideAllToast();
    // this.captureService
    //   .getImage(document.body, true)
    //   .pipe(
    //     tap(
    //       async (img) => {
    //         console.log(img);
    //         await this.util.hideLoading();
    //         await this.socialSharing.share(null, null, img, null);
    //       },
    //       async (error) => {
    //         await this.util.hideLoading();
    //         console.log(error);
    //       }
    //     )
    //   )
    //   .subscribe();
    await this.util.hideAllToast();
    this.isSharing = true;
    setTimeout(() => {
      this.changeDetector.detectChanges();
      console.log("shareReserv");
      this.captureService
        .getImage(document.body, true)
        .pipe(
          tap(
            async (img) => {
              // await this.util.hideLoading();
              this.isSharing = false;
              if (navigator.share) {
                await navigator
                  .share({ title: "GoSpread Reservation", files: [] })
                  .catch(console.error);
              } else {
                this.captureService.downloadImage(img);
              }
            },
            async (error) => {
              // await this.util.hideLoading();
              this.isSharing = false;
              console.log(error);
            },
          ),
        )
        .subscribe();
    }, 1000);
  }

  openCalendarScheduled() {
    console.log(this.formReserv.get("restaurante").value);
    if (!this.formReserv.get("restaurante").value) return false;
    console.log(this.openedCalendar);
    this.daysweek = this.calendarService.createDaysWeek();
    this.selectedweek = null;
    this.selectedhour = null;
    this.hoursoperation = [];
    this.openedCalendar = true;

    console.log(this.openedCalendar);
  }

  selectedDayWeek(index, idRestaurant) {
    this.selectedweek = this.daysweek[index];

    if (!idRestaurant) return false;

    const hoursOperation = this.filterRestaurantById(idRestaurant)
      ? this.filterRestaurantById(idRestaurant).horariosFuncionamento
      : null;

    this.hoursoperation = this.calendarService.createRangeDatesOperation(
      hoursOperation,
      this.selectedweek,
    );
  }

  selectHour(index) {
    this.selectedhour = this.hoursoperation[index];
  }

  setHourCalendar() {
    var tempDate: Date;
    if (!(this.selectedweek.date instanceof Date)) {
      const momentDate = moment(this.selectedweek.date, [
        "DD/MM/YYYY HH:mm:ss",
        "M/DD/YYYY, h:mm:ss A",
      ]).format();
      tempDate = new Date(momentDate);
    } else {
      tempDate = this.selectedweek.date;
    }
    let dateFormated = new Date(
      tempDate.valueOf() - tempDate.getTimezoneOffset() * 60000,
    );

    let dataBase = dateFormated.toISOString().replace(/\.\d{3}Z$/, "");

    const date = new Date(dataBase);

    const rest = this.selectedhour.horario % 1 === 0 ? 0 : 30;

    date.setHours(this.selectedhour.horario);
    date.setMinutes(rest);
    date.setSeconds(0);

    this.dateControl.setValue(date);
    this.formReserv.get("data-escolhida").setValue(date);
    this.disableBook = false;
    this.openedCalendar = false;
    this.selectedDate = true;
  }
}
